import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';

export type ShippingMethodsState = {
  data: string[];
  isLoading: boolean;
};

const initialState: ShippingMethodsState = {
  data: [],
  isLoading: false,
};

export default function shippingMethodsReducer(
  state: ShippingMethodsState = initialState,
  action: ActionTypes,
) {
  switch (action.type) {
    case ActionKeys.FETCH_SHIPPING_METHODS:
      return {
        ...state,
        isLoading: true,
      };
    case ActionKeys.FETCH_SHIPPING_METHODS_SUCCESS:
      return {
        data: action.payload.shippingMethods,
        isLoading: false,
      };
    case ActionKeys.FETCH_SHIPPING_METHODS_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
